<div
  class="Rtable-cell horario-cell select"
  *ngIf="isSelect"
  [ngClass]="{
    mas: isMas,
    separadorprofesores: isSeparadorProfesores,
    'sd-aforo': tipoAforo === 'SD'
  }"
  (click)="toggle.emit()"
>
  <div class="Rtable-cell--content horario-content">
    {{ time }} <span>{{ ticketsLeft }}</span>
  </div>
</div>

<div
  class="Rtable-cell horario-cell"
  *ngIf="!isSelect"
  [ngClass]="{
    naranja: isNaranja,
    rojo: isRojo,
    apagado: isApagado,
    mas: isMas,
    separadorprofesores: isSeparadorProfesores
  }"
  (click)="toggle.emit()"
>
  <div class="Rtable-cell--content horario-content">
    {{ time }} <span>{{ ticketsLeft }}</span> <span>{{ idioma }}</span>
  </div>
</div>
